"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QiHuoTableInner = exports.QiHuoTable = void 0;
var react_1 = __importStar(require("react"));
var qtpager_1 = require("../qtpager");
var tablepage_config_1 = require("./tablepage_config");
var react_router_dom_1 = require("react-router-dom");
var lodash_1 = require("lodash");
var url_1 = require("../../modules/url");
var config_1 = require("../../modules/qihuo/config");
var web_1 = require("../../modules/qihuo/web");
require("./index.less");
var hk_rule_tip_1 = require("../page/shared/hk_rule_tip");
var hk_rule_1 = __importDefault(require("../../modules/hk_rule"));
function QiHuoTable(props) {
    var _this = this;
    //香港延时市场
    var _a = (0, react_1.useState)(null), hk_delay = _a[0], SetHKDelay = _a[1];
    (0, react_1.useEffect)(function () {
        ;
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var hkdelay_result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, hk_rule_1.default.isDelayCache()];
                    case 1:
                        hkdelay_result = _a.sent();
                        if (hkdelay_result) {
                            SetHKDelay(hkdelay_result);
                        }
                        return [2 /*return*/];
                }
            });
        }); })();
    }, []);
    if (hk_delay == null)
        return react_1.default.createElement(react_1.default.Fragment, null);
    //包装获取港股延迟
    return react_1.default.createElement(QiHuoTableInner, __assign({ hk_delayinfo: hk_delay }, props));
}
exports.QiHuoTable = QiHuoTable;
/**
 * 期货表格
 * @returns
 */
function QiHuoTableInner(props) {
    var _a, _b, _c, _d, _e;
    var _f = (0, react_1.useState)([]), showdata = _f[0], SetShowData = _f[1];
    var location = (0, react_router_dom_1.useLocation)();
    var hash = location.hash.toLowerCase();
    if (hash.substring(0, 1) == '#') {
        hash = hash.substring(1);
    }
    var thishash = (0, react_1.useRef)(hash);
    //配置字段
    var hashtable_item = {};
    var qh_code = ""; // 期货代码 1、代码 2、sc/代码
    // 期货 futures_num_num(futures_113_1)
    if (!!/^options_\d+_\d+$/.test(hash)) { //商品期权
        hashtable_item = tablepage_config_1.hashqhtable['options_type_common'];
        qh_code = hash.match(/\d+/)[0];
        hashtable_item.customparams = 'variety:' + hash.match(/\d+/g)[1];
    }
    else if (!!/^futures_\d+_\d+$/.test(hash)) {
        hashtable_item = tablepage_config_1.hashqhtable['futures_num_num'];
        qh_code = hash.replace("futures_", "").replace('_', '/');
    }
    else {
        hashtable_item = tablepage_config_1.hashqhtable[hash];
        // qh_code = hashtable_item.code || ""  // 期货代码 1、代码 2、sc/代码
        qh_code = (((_a = props === null || props === void 0 ? void 0 : props.hk_delayinfo) === null || _a === void 0 ? void 0 : _a.re) && (hashtable_item === null || hashtable_item === void 0 ? void 0 : hashtable_item.hk_delayfs)) ? hashtable_item === null || hashtable_item === void 0 ? void 0 : hashtable_item.hk_delayfs : hashtable_item === null || hashtable_item === void 0 ? void 0 : hashtable_item.code;
    }
    var qh_type = hashtable_item.type;
    var block_name = (hashtable_item === null || hashtable_item === void 0 ? void 0 : hashtable_item.blockname) || "callback";
    var tableitem = (0, lodash_1.cloneDeep)(tablepage_config_1.tableqihuoitemconfig[hashtable_item.table]);
    var customparams = (hashtable_item === null || hashtable_item === void 0 ? void 0 : hashtable_item.customparams) || ""; // 自定义可变参数
    var mt = (_b = props.mt) !== null && _b !== void 0 ? _b : 0;
    // let default_sort = getDefaultSort(tableitem) //默认排序  
    var default_sort = getDefaultSort(tableitem); //默认排序  
    // console.info('default_sort', default_sort)
    // let url_sort_direct = getQueryParams("sr")
    // let sort_direct = url_sort_direct != null ? url_sort_direct : default_sort.sort_direct // 优先url
    var sort_direct = default_sort.sort_direct;
    var _g = (0, react_1.useState)(0), count = _g[0], SetCount = _g[1];
    var _h = (0, react_1.useState)(1), nowindex = _h[0], SetNowIndex = _h[1];
    var _j = (0, react_1.useState)(default_sort.sort), sortitem = _j[0], SetSortItem = _j[1];
    var _k = (0, react_1.useState)(sort_direct), sortdirect = _k[0], SetSortDirect = _k[1]; // 优先url
    var pagesize = 20;
    var getData = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var qihuodata;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, (0, web_1.getListQiHuoWithType)(qh_type, qh_code, tableitem.filter(function (v) { return v.type == 'quote'; }).map(function (v) { return config_1.QiHuoItem[v.value]; }), nowindex, pagesize, sortdirect, sortitem, block_name, customparams)];
                    case 1:
                        qihuodata = _b.sent();
                        if (((_a = qihuodata === null || qihuodata === void 0 ? void 0 : qihuodata.result) === null || _a === void 0 ? void 0 : _a.length) >= 0)
                            SetShowData(qihuodata === null || qihuodata === void 0 ? void 0 : qihuodata.result);
                        SetCount(qihuodata === null || qihuodata === void 0 ? void 0 : qihuodata.count);
                        return [2 /*return*/];
                }
            });
        });
    };
    (0, react_1.useEffect)(function () {
        if (hash != thishash.current) {
            SetNowIndex(1);
            SetSortItem(default_sort.sort);
            SetSortDirect(default_sort.sort_direct);
        }
        thishash.current = hash;
        getData();
    }, [nowindex, sortdirect, sortitem, hash, qh_code]);
    var changeSort = function (tosortitem) {
        SetSortItem(tosortitem);
        if (sortitem == tosortitem) {
            if (sortdirect == 'asc') {
                SetSortDirect('desc');
            }
            else {
                SetSortDirect('asc');
            }
        }
        else {
            SetSortDirect('desc');
        }
    };
    return (react_1.default.createElement("div", { className: "quotetable", style: mt > 0 ? { marginTop: mt } : {} },
        react_1.default.createElement("table", null,
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null, tableitem.filter(function (v) { return v.hide != true; }).map(function (v, index) {
                    return react_1.default.createElement("th", { key: index, className: v.sort ? 'sort' : '', title: v.sort ? '点击排序' : '', onClick: function () { if (v.sort) {
                            changeSort(config_1.ListQHItemConfig === null || config_1.ListQHItemConfig === void 0 ? void 0 : config_1.ListQHItemConfig[config_1.QiHuoItem[v.value]].sort);
                        } } },
                        v.title,
                        v.sort && (config_1.ListQHItemConfig === null || config_1.ListQHItemConfig === void 0 ? void 0 : config_1.ListQHItemConfig[config_1.QiHuoItem[v.value]].sort) == sortitem && sortdirect == 'desc' &&
                            react_1.default.createElement("span", { className: "icon_down" }),
                        v.sort && (config_1.ListQHItemConfig === null || config_1.ListQHItemConfig === void 0 ? void 0 : config_1.ListQHItemConfig[config_1.QiHuoItem[v.value]].sort) == sortitem && sortdirect == 'asc' &&
                            react_1.default.createElement("span", { className: "icon_up" }));
                }))),
            react_1.default.createElement("tbody", null, showdata.map(function (v, index) {
                return react_1.default.createElement("tr", { key: index }, tableitem.filter(function (v) { return v.hide != true; }).map(function (v2, index2) {
                    var _a, _b;
                    var td_value = react_1.default.createElement(react_1.default.Fragment, null);
                    if (v2.type == 'quote' && v[config_1.QiHuoItem[v2.value]] && v[config_1.QiHuoItem[v2.value]].html) {
                        td_value = v[config_1.QiHuoItem[v2.value]].html;
                        if (((_b = (_a = v[config_1.QiHuoItem[v2.value]].html) === null || _a === void 0 ? void 0 : _a.props) === null || _b === void 0 ? void 0 : _b.children) == '小型道指当月连续') {
                            td_value = react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("i", { className: "icon_hot_qh" }),
                                td_value);
                        }
                    }
                    return (react_1.default.createElement("td", { key: index2, className: v2.tdclass ? v2.tdclass : '' },
                        v2.type == 'index' && ((nowindex - 1) * pagesize + index + 1),
                        // v2.type == 'quote' && v[QiHuoItem[v2.value!]] && v[QiHuoItem[v2.value!]].html
                        v2.type == 'quote' && td_value));
                }));
            }))),
        ((_c = props === null || props === void 0 ? void 0 : props.hk_delayinfo) === null || _c === void 0 ? void 0 : _c.re) && ((_d = props === null || props === void 0 ? void 0 : props.hk_delayinfo) === null || _d === void 0 ? void 0 : _d.message) && (hashtable_item === null || hashtable_item === void 0 ? void 0 : hashtable_item.show_hk_delay_info) == true && react_1.default.createElement(hk_rule_tip_1.HKDelayRoleTip, { tiptxt: (_e = props === null || props === void 0 ? void 0 : props.hk_delayinfo) === null || _e === void 0 ? void 0 : _e.message, mt: 10 }),
        count > 0 &&
            react_1.default.createElement(qtpager_1.QTPager, { count: count, pagesize: pagesize, nowindex: nowindex, onChangePager: function (toindex) { SetNowIndex(toindex); } })));
}
exports.QiHuoTableInner = QiHuoTableInner;
/**
 * 获取默认的排序设置
 * @param config
 * @returns
 */
function getDefaultSort(config) {
    var url_sort_direct = (0, url_1.getQueryParams)("amp;sr") || (0, url_1.getQueryParams)("sr"); // 排序方向 &amp;转义符
    var url_sort_item = (0, url_1.getQueryParams)("st"); // 排序字段
    // console.info(url_sort_direct, url_sort_item)
    var finddefault = config.find(function (v) { return v.sort_default; });
    // 取url配置
    if (url_sort_item != null) {
        finddefault = config.find(function (v) { var _a; return ((_a = v.sort_alias) === null || _a === void 0 ? void 0 : _a.toLowerCase()) == url_sort_item.toLowerCase(); });
        // console.info(finddefault)
    }
    // 取默认配置
    if (url_sort_item == null && finddefault == undefined) {
        finddefault = config.find(function (v) { return v.sort_default; });
    }
    var url_dir = url_sort_direct == -1 ? 'desc' : url_sort_direct == 1 ? 'asc' : url_sort_direct;
    if (finddefault) {
        return {
            sort: config_1.ListQHItemConfig[config_1.QiHuoItem[finddefault.value]].sort,
            sort_direct: url_dir != null ? url_dir : finddefault.sort_direct
        };
    }
    return {
        sort: '',
        sort_direct: 'desc'
    };
}
